import React from 'react';
import {SingleProductEnum} from "@/constants/commerce-enum";
import {Percent} from "lucide-react";
import {IProductDetailsProps} from "@/interface/components/product/product-details";

interface IProps {
    data: IProductDetailsProps;
}

const PriceInfo: React.FC<IProps> = ({data}) => {
    return (
        <div
            className="w-full flex flex-wrap border-b pb-6 border-gray-200 items-center justify-between">
            <div className={"w-full flex flex-wrap items-center justify-between"}>
                <span className="text-gray-400 text-xl">{SingleProductEnum?.price} :</span>
                {
                    data?.productItem?.discount_percentage ? (
                        data?.productItem?.price ?
                            <div className="flex items-center justify-between gap-1 flex-wrap">
                                <del
                                    className="text-gray-400 text-lg">{data?.productItem?.price?.toLocaleString("fa")}</del>
                                <h6
                                    className="w-auto px-1 py-0.5 text-white items-center font-bold justify-center text-sm h-auto flex  rounded-md bg-red-500">
                                    {data?.productItem?.discount_percentage?.toLocaleString("fa")}
                                    <Percent className="w-3.5 h-3.5"/>
                                </h6>
                            </div> : null
                    ) : null
                }
            </div>
            <div className={"w-full flex mt-3 flex-wrap gap-1 items-center justify-end"}>
                <h2 className="text-2xl font-bold">{data?.productItem?.sale_price?.toLocaleString("fa")}</h2>
                <span className="text-sm font-bold">{SingleProductEnum?.Toman}</span>
            </div>
        </div>
    );
};

export default PriceInfo;